<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/GPIuIz/tc-custom/9780830861255.jpg?1696374743350" alt="This image is the cover for the book The Good and Beautiful Community, The Good and Beautiful Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Good and Beautiful Community, The Good and Beautiful Series
      </h1>
      <p class="bookDescription body article font2">
        <p>In this Good and Beautiful Series book, James Bryan Smith helps us know how to live in relationship with others as apprentices of Jesus. "Apprentices of Jesus are not part-time do-gooders," he writes. "They live in continuous contact with the kingdom of God, and are constantly men and women <em>in whom Christ dwells.</em> They do not sometimes tell the truth, sometimes live sacrificially or sometimes forgive. There are myriad opportunities for us to impact the world in which we live."</p> <p>Yet many times we've gotten it wrong, tending to emphasize personal faith over social justice or vice versa. In these pages Jim Smith shows us how to bring spiritual formation and community engagement together, and then once again offers spiritual practices that root new, true narratives about God and the world in our souls. His insight and humility as a fellow learner with us will lead us to live in authentic ways as a good and beautiful community of Christ-followers, shining the light of the Spirit into every relationship.</p> <p>The Good and Beautiful Series includes four essential discipleship books from James Bryan Smith. Work through these proven Bible study resources individually or with a group to learn who God is, what it means to be a Christian, how to live in community, and how to address toxic self-narratives that hinder spiritual growth.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        James Bryan Smith
      </h2>
      
      <p class="authorDescription body article"><p>James Bryan Smith (MDiv, Yale University Divinity School, DMin, Fuller Seminary) is a theology professor at Friends University in Wichita, Kansas, and a writer and speaker in the area of Christian spiritual formation. He also serves as the director of the Apprentice Institute for Christian Spiritual Formation at Friends University. A founding member of Richard J. Foster's spiritual renewal ministry, Renovaré, Smith is an ordained United Methodist Church minister and has served in various capacities in local churches. Smith is also the editor of <em>A Spiritual Formation Workbook, Devotional Classics</em> (with Richard Foster), <em>Embracing the Love of God, Rich Mullins: An Arrow Pointing to Heaven</em> and <em>Room of Marvels</em>.</p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      InterVarsity Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?45718462